import { createSlice } from "@reduxjs/toolkit";
// Helper function to get initial state from URL params
const getInitialState = () => {
  const searchParams = new URLSearchParams(window.location.search);

  return {
   packageList: [],
  packageSummeryData: [],
  queryBizLayerData: [], // get interface and brand name
  selectedPackage: searchParams.get("single_package_name") || [], //filter (single package)
  selectedMultiplePackages: searchParams.get("package_name")?.split(",") || [], //filter (multiple packages)
  selectedProcessName: searchParams.get("process_id")?.split(",") || [], //filter
  selectedPackageStatus: searchParams.get("status")?.split(",") || [], //filter
  selectedPackageBrand: searchParams.get("brand_id")?.split(",") || [], //filter
  selectedPackageDateRange: [], //filter
  selectedPackageInterface: searchParams.get("interface_id")?.split(",") || [], //filter
  isPackagesLoading: false, // loader
  isFilterDateRangesClear: false,
  page: parseInt(searchParams.get("page") || "0", 10),
  rowsPerPage: 10,
  selectedRows: [],
  sort: {
    keytoSort: "start_time",
    direction: "desc",
  },
  filterDataList :[], // Filter data
  totalPackages: 0, // Count Total number of packages
  packageFilterDataList: [],
  isFilterAnyPackages: false,
  packagesFilters: [],
  hasPackageDataBeenFetched: false
  };
};
const initialState = getInitialState();

const monitoringPackagesSlice = createSlice({
  name: "monitoringPackages",
  initialState,
  reducers: {
    setPackageList: (state, action) => {
      state.packageList = action.payload;
    },
    setPackageSummeryData: (state, action) => {
      state.packageSummeryData = action.payload;
    },
    setQueryBizLayerData: (state, action) => {
      state.queryBizLayerData = action.payload;
    },
    setSelectedPackage: (state, action) => {
      state.selectedPackage = action.payload;
    },
    setSelectedProcessName: (state, action) => {
      state.selectedProcessName = action.payload;
    },
    setSelectedPackageStatus: (state, action) => {
      state.selectedPackageStatus = action.payload;
    },
    setSelectedPackageBrand: (state, action) => {
      state.selectedPackageBrand = action.payload;
    },
    setSelectedPackageInterface: (state, action) => {
      state.selectedPackageInterface = action.payload;
    },
    setSelectedPackageDateRange: (state, action) => {
      state.selectedPackageDateRange = action.payload;
    },
    setSelectedMultiplePackages: (state, action) => {
      state.selectedMultiplePackages = action.payload;
    },
    setSort: (state, action) => {
      state.sort = action.payload;
    },
   setFilterDataList: (state, action) => {
     state.filterDataList = action.payload;
   },
    setSelectedRows: (state, action) => {
      state.selectedRows = action.payload;
    },
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setRowsPerPage: (state, action) => {
      state.rowsPerPage = action.payload;
    },
    setIsPackagesLoading: (state, action) => {
      state.isPackagesLoading = action.payload;
    },
    setIsFilterDateRangesClear: (state, action) => {
      state.isFilterDateRangesClear = action.payload;
    },
    setTotalPackages: (state, action) => {
      state.totalPackages = action.payload;
    },
    setPackagesFilters: (state, action) => {
      state.packagesFilters = action.payload;
    },
    setIsFilterAnyPackages: (state, action) => {
      state.isFilterAnyPackages = action.payload;
    },
    setPackageFilterDataList: (state, action) => {
      state.packageFilterDataList = action.payload;
    },
     setPackageDataBeenFetched: (state, action) => {
      state.hasPackageDataBeenFetched = action.payload;
    },
    resetStateOfMonitorPackage: () => getInitialState(), // reset everything
  },
});

export const {
  setPackageList,
  setPackageSummeryData,
  setQueryBizLayerData,
  setSelectedPackage,
  setSelectedMultiplePackages,
  setSelectedProcessName,
  setSelectedPackageStatus,
  setSelectedPackageBrand,
  setSelectedPackageDateRange,
  setSelectedPackageInterface,
  setSort,
  setFilterDataList,
  setSelectedRows,
  setPage,
  setRowsPerPage,
  setIsPackagesLoading,
  setIsFilterDateRangesClear,
  setTotalPackages,
  setPackageFilterDataList,
  setIsFilterAnyPackages,
  setPackagesFilters,
  setPackageDataBeenFetched,
  resetStateOfMonitorPackage
} = monitoringPackagesSlice.actions;

export default monitoringPackagesSlice.reducer;
